import React, { useEffect, useState } from "react";
import Layout from "../../../app/Layout";
import HeaderContent from "../General/HeaderContent";
import Breadcrumb from "../General/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEdit, faEye, faListAlt, faTrash} from "@fortawesome/free-solid-svg-icons";
import MaterialtableDemo from "../../components/plugins/MaterialTableDemo";
import SpinnerLoading from "../../components/Spinners/SpinnerLoading";
import { updateStateModalLarge } from "../../../actions/modalActions";
import ModalBasicwithRedux from "../../../containers/ModalLargewhithRedux";
import FormularioCampaña from './FormularioCampaña';
import "./Trabajadores.scss";

//Reduxt
import {useDispatch, useSelector } from "react-redux";
import { eliminarCampaign, listarCampaigns } from "../../../actions/campaignsActions";
import { Button } from "react-bootstrap";
import EditarCampaña from "./EditarCampaña";
import { Link } from "react-router-dom";
 
const Campaigns = () => {
  //State
  const dispatch = useDispatch();
  const {usuario} = useSelector(state=>state.usuario)
  const {campaigns,loading} = useSelector(state=>state.campaigns)

  useEffect(() => {
   dispatch(listarCampaigns())
  }, []);

  const handleModalNuevo = () => {
    dispatch(updateStateModalLarge(<FormularioCampaña />, 'Nueva Campaña'));
  }
  const handleEditar = (registro) => {
    dispatch(updateStateModalLarge(<EditarCampaña registro={registro} />, 'Editar Campaña'));
  }
  const handleEliminar = (id) =>{
    dispatch(eliminarCampaign(id))
  }
  return (
    <Layout>
      <div className="Trabajadores">
        <div className="Trabajadores__container">
          <div className="Trabajadores__head">
            <HeaderContent title="Campañas" icon="group" />
            <Breadcrumb
              link={[
                { url: "/inicio", nombre: "Inicio", icon: "fas fa-home" },
          { url: "", nombre: "Campañas" },
              ]}
            />
          { usuario.id_tp_nivel_usuario==="12" ? <button className="btn btn-primary" onClick={()=>handleModalNuevo()}> Nueva Campaña </button> : null}
          </div>
          <div className="Trabajadores__body container-fluid  px-0 content-actions mt-3">
          <ModalBasicwithRedux />
            <SpinnerLoading loading={loading}>
              <div className="box mt-5">
                <div className="box-header with-border">
                  <h5
                      style={{ color: "#434343" }}
                    >
                    <FontAwesomeIcon icon={faListAlt} /> Lista de Campañas
                  </h5>
                
                </div>
                <div className="box-primary">
                  <MaterialtableDemo
                    colums={colums(handleEliminar,handleEditar)}
                    tabla={campaigns}
                    keyCol="id_camp"
                  />
                </div>
              </div>
            </SpinnerLoading>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Campaigns;

/**====================== TABLA =========== */

const colums = (handleEliminar,handleEditar) => [
  {
    text: 'ID',
    key: 'id_camp',
    className: 'id_camp',
    width: 50
  }
  ,
  
  {
    text: "Producto",
    key: "nombre_proyecto",
    align: "center",
    sortable: true,
    className: "nombre_proyecto",
  },
  {
    text: "Fecha Inicio",
    key: "fecha_inicio",
    align: "center",
    sortable: true,
    className: "fecha_inicio"
  }
  ,
  {
    text: "Fecha Fin",
    key: "fecha_fin",
    align: "center",
    className: "fecha_fin",
    sortable: true
  }
  ,
  {
    text: "Creado el",
    key: "fecha_registro",
    align: "center",
    className: "fecha_registro",
    sortable: true
  }
  ,
  {
    text: "Estado",
    key: "estado",
    align: "center",
    className: "estado",
    sortable: true,
    cell:(record) => record.estado!=="1" ? 'Culminado' : 'En progreso'
  }
  ,
  {
    text: "Acciones",
    key: "Acciones",
    align: "center",
    className: "Acciones",
    sortable: false,
    cell:(record) =>  <>
     <Button
      variant='warning'
      size='xs'
      type="button"
      onClick={() => handleEditar(record)}
    >
      <FontAwesomeIcon icon={faEdit} />
    </Button>
    <Link   className="btn btn-info btn-xs"
     to={`examinar-campaign/${record.producto}`}
     >
    <FontAwesomeIcon icon={faEye} />
    </Link>
    <Button
      variant='danger'
      size='xs'
      type="button"
      onClick={() => handleEliminar(record.id_camp)}
    >
      <FontAwesomeIcon icon={faTrash} />
    </Button>
   
  </>
  }
  
];
